import {cn} from '../../lib/utils';
import {CountBadge} from '../CountBadge';
import {Icon} from '../Icon/Icon';
import {
  Tabs as ShadcnTabs,
  TabsContent as ShadcnTabsContent,
  TabsList as ShadcnTabsList,
  TabsTrigger as ShadcnTabsTrigger,
  type TabsVariant
} from '../shadcn/tabs';

import type {TabItem} from './tab.types';
import type {ReactNode} from 'react';

interface TabsProps {
  tabs: TabItem[];
  value?: string;
  defaultValue?: string;
  onValueChange?: (value: string) => void;
  /** Content panels — use conditional rendering or TabsContent */
  children?: ReactNode;
  className?: string;
  variant?: TabsVariant;
  listClassName?: string;
  triggerClassName?: string;
  hideBorder?: boolean;
}

export function Tabs({
  tabs,
  value,
  defaultValue,
  onValueChange,
  children,
  className,
  variant,
  listClassName,
  triggerClassName,
  hideBorder
}: TabsProps) {
  return (
    <ShadcnTabs
      value={value}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      className={className}
    >
      <ShadcnTabsList variant={variant} className={listClassName} hideBorder={hideBorder}>
        {tabs.map(tab => (
          <ShadcnTabsTrigger
            key={tab.value}
            value={tab.value}
            disabled={tab.disabled}
            variant={variant}
            className={cn('group/tab', triggerClassName)}
          >
            {tab.icon && (
              <Icon name={tab.icon} className={cn('size-4 shrink-0', tab.iconClassName)} />
            )}
            {tab.label}
            {tab.count !== undefined && (
              <CountBadge
                count={tab.count}
                className="group-data-active/tab:border-transparent group-data-active/tab:bg-background-selected-strong group-data-active/tab:text-brand-accent"
              />
            )}
          </ShadcnTabsTrigger>
        ))}
      </ShadcnTabsList>
      {children}
    </ShadcnTabs>
  );
}

export {ShadcnTabsContent as TabsContent};
